import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Responsive from '../../components/Responsive';
import MessengerList from '../../components/views/messenger/MessengerList';
import MessengerView from '../../components/views/messenger/MessengerView';
import { checkDefaultTab, conditionalWidth } from '../../utils/useful';
import GroupInformation from '../../components/views/messenger/info/GroupInformation';
import StagesManager from '../../components/StagesManager';
import SettingsSwitcher from './database/SettingsSwitcher';
import { SettingsFrames } from '../../variables/AppletPages';
import TopicInfo from '../../components/views/messenger/sideBar/TopicInfo';
import ContactInfo from '../../components/views/messenger/sideBar/ContactInfo';
import SupportInfo from '../../components/views/messenger/sideBar/SupportInfo';
import Header from '../../components/header/Header';
import SocketServices from '../../utils/socket.services';
import HttpServices from '../../utils/Http.services';
import SidebarView from '../../components/SidebarView';
import Topics from '../../components/views/messenger/sideBar/Topics';
import CollectionToolbar from '../../components/header/CollectionToolbar';
import MessengerToolbar from '../../components/header/MessengerToolbar';

class MessengerAdminView extends Component {

    state = {
        stage: 1,
        messengerInfo: false,
        modules: Object.values(SettingsFrames.pages),
        headerConfig: {
            showToolbar: false, showSettings: true, showFrames: 'messenger',
        },
        show: false
    }

    componentDidMount() {

        if (this.props.setHeader) {
            this.props.setHeader({})
        }
        this.showHeader(false, () => {
            this.removePotentialUser()
            this.setScope(() => {

                this.init()
                this.checkDefaultTab()

            })
            // this.props.selectPotentialUser()
            // this.setState({ width: window.innerWidth })
            // window.addEventListener('resize', this.updateWidth)
            this.updateWidth()
        })
        if (this.props.defaultHeaderConfig) {
            this.setState({ headerConfig: this.props.defaultHeaderConfig })
        }

    }


    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
        if (prevProps.height != this.props.height) {
            this.updateWidth()
        }
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                // this.checkDefaultTab()
            })
        }

        if (prevProps.scope != this.props.scope) {
            this.setScope()
        }
        // if (this.props.windowData.path[this.props.baseUrl.length + 1] != prevProps.windowData.path[this.props.baseUrl.length + 1]) {

        //     this.setMessenger()
        // }
    }

    setScope = (cb) => {

        let scope = this.props.scope

        if (this.props.page) {
            scope = { type: 'frame', item: this.props.page }
        }

        scope = scope ?? {}
        this.setState({ scope: scope }, () => {

            if (cb) {
                cb()
            }
        })
    }


    selectPotentialUser = () => {
        // console.log("selectPotentialUser")
        let potentialUser = JSON.parse(JSON.stringify(this.props.applet))
        this.setState({ potentialUser, messenger: null })
    }

    sendNotif = (type, value, messenger, time = 1, tryTime = 0, cb) => {
        setTimeout(() => {
            if (SocketServices.socket?.connected) {
                SocketServices.emit('handleNotif', { type, value, messenger }, null, (info, err) => {
                    if (cb)
                        cb()
                })
            }
            else {
                if (tryTime < 10) {
                    this.sendNotif(type, value, messenger, time + 5, tryTime + 1, cb)
                }
            }
        }, time * 1000);
    }

    removePotentialUser = () => {
        // console.log("removePotentialUser")
        let potentialUser = null
        this.setState({ potentialUser })
    }

    selectApplet = (value, cb) => {
        if (this.props.applet?.settings?.type != 'support') {

            this.setState({ currentApplet: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
    }
    removeUser = (item, cb) => {
        this.setState({ isLoader: true })
        HttpServices.request('removeUser', item, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            let userInfo = this.state.userInfo
            let currentMessenger = this.state.currentMessenger
            userInfo = {}
            currentMessenger = {}
            if (fetchResult.info) {
                let messenger = fetchResult.info
                if (!Array.isArray(messenger)) {
                    messenger = [messenger]
                }
                this.props.actions.updateMessengers(messenger)
                setTimeout(() => {
                    this.setMessenger(fetchResult.info, () => {
                        this.setState({ isLoader: false })
                        if (cb) {
                            cb()
                        }
                    })
                }, 50);
            }
            this.setState({ userInfo, currentMessenger })
        })
    }
    init = () => {
        // if (!this.props.adminView) {}
        // setTimeout(() => {
        // console.log('this.prrrba', this.props.baseUrl?.length)
        // console.log('this.props.windowData.path.length', this.props.windowData.path.length)
        // if (this.props.windowData.path.length == this.props.baseUrl?.length + 2) {
        //     this.setMessenger()
        // }
        let myId = this.props.user?.info?._id
        this.setState({ myId }, () => {
        })


        if (this.props.setHeader && this.props.isApplet) {


            this.props.setHeader({
                'toolbar': this.toolbarView,
                "showToolbar": true,
                'title': this.props.page?.name,
                'subtitle': this.props.page?.subtitle,
                backAction: (this.props.applet && this.props.applet.features && this.props.applet.features[0] == 'Messenger') ? (() => { this.props.changeMessengerStage('main') }) : false
            })

        } else {
            this.props.setHeader({})
        }
        // let data = this.props?.data
        // if (data?.path?.length > 1) {
        //     let id = data.path[1]
        //     if (id.startsWith("h=")) {
        //     } else { }
        //     // this.stageManager.changeStage('room', null, null, true)
        // } else {
        //     // this.stageManager.changeStage('home', null, null, true)
        // }
        // }, 1000);
    }


    toolbarView = () => {
        return (
            <MessengerToolbar setCurrentHead={this.setCurrentHead} currentHead={this.state.currentHead} permissions={this.props.permissions} isMobile={this.props.isMobile} showStack={this.state.showStack} functionsHandler={this.toolbarFunctionsHandler} colors={this.props.colors} language={this.props.language} frame={this.props.page} width={this.props.width} headers={this.props.headers} view={this.state.currentView} hasFilter={this.state.hasFilter} hasSortedBy={this.state.hasSortedBy} hasGroupBy={this.state.hasGroupBy} />
        )
    }

    updateWidth = () => {
        // this.setState({ width: window.innerWidth })
        if (this.MessengerView) {
            let bound = this.MessengerView.getBoundingClientRect()
            this.setState({ mwidth: bound.width, mheight: bound.height })
        }
    }

    openOne = (item, frame, myFrame) => {

        let potentialUser = item.hub
        // console.log('potentialUser', potentialUser, item, myFrame)
        this.setState({ stage: 2, potentialUser, messenger: null, potentialFrame: frame, myPotentialFrame: myFrame })
        // this.setMessenger(item, () => {
        this.updateWidth()
        let id = 'h=' + potentialUser?.username
        // console.log(id)
        this.props.changePage(null, { f: frame._id, h: potentialUser?.username, })
        // })

        // let newLink
        // newLink = this.props.baseUrl
        // newLink = this.props.baseUrl.splice(2)
        // newLink.push('admin')
        // newLink.push(id)
        // this.props.changeWindowLink(newLink)
        // this.fetchOne(item)
    }


    openMessenger = (messenger) => {

        let potentialUser = messenger.hub
        // console.log('openMessenger', messenger)

        this.setMessenger(messenger, () => {
            this.setState({ stage: 2, potentialUser, potentialFrame: null, myPotentialFrame: null }, () => {

                this.updateWidth()
                let id = messenger?._id
                // console.log(id)




                // console.log(this.props.baseUrl)
                // console.log(this.props.windowData.path)

                // console.log(newLink)


                // return
                if (this.props.changePage) {

                    let newLink = []
                    if (this.props.inApplet) {
                        newLink = [this.props.windowData.path[this.props.baseUrl.length]]
                    } else {
                        // newLink = [this.props.windowData.path[this.props.baseUrl.length]]
                    }

                    // newLink = [this.props.windowData.path[this.props.baseUrl.length]]//JSON.parse(JSON.stringify(this.props.windowData.path))
                    // newLink.splice(0, this.props.baseUrl.length)
                    // newLink.push('admin')
                    newLink.push(id)
                    this.props.changePage(newLink)
                } else {

                    // let newLink = this.props.baseUrl

                    // newLink.push(id)

                    // this.props.changeWindowLink(newLink)

                }
            })
            // this.props.changePage(null, { f: frame._id, h: potentialUser?.username, })
        })


        // this.fetchOne(item)
    }

    closeOne = () => {
        // console.log("closeOne")
        // let newLink
        // newLink = this.props.baseUrl
        // newLink = this.props.baseUrl.splice(2)
        // newLink.push('admin')
        this.setState({ stage: 1, messenger: null, potentialUser: null, potentialFrame: null }, () => {
            this.props.changePage([this.props.page?._id])

        })
    }


    setTopics = (value) => {
        this.setState({ topics: value }, () => {
            // console.log('this.state.topics',this.state.topics)
            if (this.state.topics.length > 0) {
                // this.TopicsView.open()
            }
        })
    }
    updateGroup = (data, messengerId) => {
        // console.log('updateGroup')
        let body = data ?? {}
        body.frame = this.props.page._id
        body.applet = this.props.applet._id
        body._id = messengerId
        HttpServices.request("createGroupMessenger", body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }

        })
    }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.messenger._id
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
            // this.fetchData(true)
            this.closeOne()
        })
    }

    setMessenger = (messenger, cb) => {
        // console.log('SETmessenger', messenger)
        // if (typeof messenger != 'object') {
        //     messenger = this.props.messengers
        // }
        this.setState({ topics: [], messenger: messenger }, () => {
            if (cb) {
                cb()
            }
        })
        // let token = ''//getVToken()
        // subscribeAdmin(this.state.topicId, token, 'visitor', this.visitorInfoUpdate)
    }





    setData = (key, value, reference, cb) => {
        if (reference == 'Messenger') {
            this.setState({ [key]: value }, () => {
                console.log('messengerInfoChanged', this.state.messengerInfo)
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }
    functionsHandler = (type, name, data, extra) => {
        if (this[name]) {
            this[name](data, extra)
        }
    }
    // setHeader = (key, value) => {
    //     if (this.header) {
    //         if (typeof key == 'object') {
    //             let object = {
    //                 showSettings: true,
    //                 showFrames: 'static'
    //             }
    //             if (this.props.defaultHeaderConfig) {
    //                 object = { ...this.props.defaultHeaderConfig }
    //             }
    //             for (const [okey, ovalue] of Object.entries(key)) {
    //                 object[okey] = ovalue
    //             }
    //             if (object.showSettings && this.props.showSettings) {
    //                 object.showSettings = this.props.showSettings
    //             }
    //             this.setState({ headerConfig: object }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //         else {
    //             this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //     }
    // }
    changeWindow = (list, info) => {
        if (Array.isArray(list)) {
            let finalList = []
            list.forEach(value => {
                let one = value
                console.log('valueeee', value)
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        one = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
                if (one) {
                    finalList.push(one)
                }
            });
            let data = { type: 'applet', path: finalList }
            if (info) {
                data.info = info
            }
            this.props.changeWindow('applet', data)
        }
    }

    
    changePage = (page, info) => {
        // console.log('changePage1', page)
        // console.log('this.state', this.props.frames)
        // this.props.frames.map((element) => {
        //     if (element._id == page && element.slug) {
        //         page = element.slug
        //     }
        // })
        let extraPath = Array.isArray(page) ? page : [page]
        let fullPath = [...this.props.baseUrl, ...extraPath]
        this.changeWindow(fullPath, info)
    }


    checkDefaultTab = () => {
        checkDefaultTab(this.props.windowData, [...this.props.baseUrl, 'messenger'], this.state.modules, this.props.width, (pageInfo, pageType, def) => {
            def = def ?? ''
            pageType = pageType != null ? pageType : def
            if (pageType != null) {
                this.setState({ oldData: this.props.windowData, path: def, pageType: pageType }, () => {
                    setTimeout(() => {
                        this.setState({ page: pageInfo, pageType, headers: pageInfo?.fields ?? pageInfo?.headers, pageStatus: 200 }, () => {
                            if (this.stageManager && ['main', 'settings'].includes(pageType)) {
                                this.stageManager.changeStage((pageType), () => {
                                })
                            }
                            else {
                                // console.log('pageInfo, pageType, def',pageInfo, pageType, def)

                                this.checkUrlMessenger(0, pageType)
                            }
                        })
                    }, 10);
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        })
    }
    checkUrlMessenger = (tryTime, key, cb) => {
        // console.log('*checkUrlMessenger')
        if (this.props.messengers.status == 'gathered') {
            let messenger
            this.props.messengers.list.map((element) => {
                // console.log('elementcheck',element)
                // console.log('keycheck',key)
                if (element._id == key) {
                    messenger = element
                }
            })
            this.setMessenger(messenger)
        } else {
            if (tryTime < 20) {
                setTimeout(() => {
                    this.checkUrlMessenger((tryTime + 1), key, cb)
                }, 10);
            }
        }
    }

    // setHeader = (key, value) => {
    //     if (this.header) {
    //         if (typeof key == 'object') {
    //             let object = {
    //                 showSettings: true,
    //                 showFrames: 'static',
    //                 "showToolbar": true,

    //             }
    //             if (this.props.defaultHeaderConfig) {
    //                 object = { ...this.props.defaultHeaderConfig }
    //             }
    //             for (const [okey, ovalue] of Object.entries(key)) {
    //                 object[okey] = ovalue
    //             }
    //             if (object.showSettings && this.props.showSettings) {
    //                 object.showSettings = this.props.showSettings
    //             }
    //             this.setState({ headerConfig: object }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //         else {
    //             this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //     }
    // }


    showHeader = (prop, cb) => {
        this.setState({ show: prop }, () => {
            if (cb) {
                cb()
            }
        })
    }

    changeMessengerStage = (stage) => {
        let newLink = []
        // let newLink = this.props.baseUrl.splice(2)
        // newLink.push(this.props.applet?.urlcode)
        newLink.push('admin')
        // console.log('newwwwwwwwwwlink', this.state, this.props)
        this.props.changeWindowLink(newLink)
        this.stageManager.changeStage(stage)
        this.showHeader(false)
    }

   

    render() {
        // console.log('this.props.page!', this.props.page)
        return (
            <div className=' w-100 h-100 d-flex flex-column bg-white window-content-radius'>
                {/* <div style={{ position: 'relative', top: 0, display: !this.state.show && 'none' }}>
                    <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={'this.props.type'} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} setHeader={this.setHeader} backActionMobile={this.backActionMobile} />
                </div> */}
                {/* <p>jwfkwf</p> */}
                {/* <div className='w-100' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div> */}
                <StagesManager ref={el => this.stageManager = el} height={'0px'} className={'flex-1'} fast={true}>
                    <div stage={0} stageName='main' className="d-flex m-0 h-100" >
                        <Responsive height="100%" width={this.props.width} media={{ xs: !this.state.messengerInfo ? "12" : "none", sm: !this.state.messengerInfo ? "12" : 'none', md: '4', lg: "4", xl: "3" }}>
                            <div className=' h-100 scroll-no-scrollbar  w-100 d-flex flex-column'>
                                <MessengerList scope={this.state.scope} showHeader={this.showHeader}
                                    language={this.props.language}
                                    selectApplet={this.selectApplet}
                                    isApplet={this.props.isApplet}
                                    variables={this.props.variables}
                                    page={this.props.page}
                                    frame={this.props.page}
                                    adminView={true}
                                    openOne={this.openOne} openMessenger={this.openMessenger} closeOne={this.closeOne} setMessenger={this.setMessenger} messenger={this.state.messenger} width={this.props.width} functionsHandler={this.functionsHandler} applet={this.props.applet} colors={this.props.colors} />


                                {this.state.messengerInfo && (
                                    <>
                                        {this.state.messenger?.type == 'group' ? (
                                            <GroupInformation topics={this.state.topics} updateGroup={this.updateGroup} language={this.props.settings.language} isLoader={this.state.isLoader} myId={this.state.myId} messenger={this.state.messenger} messengerInfo={this.state.messengerInfo} setData={this.setData} width={this.props.width} removeUser={this.removeUser} setMessenger={this.setMessenger} colors={this.props.colors} />
                                        ) : (
                                            this.state.messenger?.type == 'topic' ? (
                                                <TopicInfo myId={this.state.myId} language={this.props.settings.language} messenger={this.state.messenger} width={this.props.width} height={"100%"} changeStage={this.changePage} setData={this.setData} messengerInfo={this.state.messengerInfo} colors={this.props.colors} />
                                            ) : (
                                                this.state.messenger?.type == 'support' ? (
                                                    <SupportInfo myId={this.state.myId} language={this.props.settings.language} messenger={this.state.messenger} width={this.props.width} height={"100%"} changeStage={this.changePage} setData={this.setData} messengerInfo={this.state.messengerInfo} colors={this.props.colors} applet={this.props.applet} />
                                                ) : (
                                                    <ContactInfo myId={this.state.myId} language={this.props.settings.language} messenger={this.state.messenger} width={this.props.width} height={"100%"} changeStage={this.changePage} setData={this.setData} messengerInfo={this.state.messengerInfo} colors={this.props.colors} />
                                                )
                                            )
                                        )}
                                    </>
                                )}
                                <SidebarView isDesktop={this.props.isDesktop} onClosed={this.onClosed} hight={"100%"} width={this.props.width} ref={el => this.TopicsView = el} hideOverlay={false} widthCondition={{ xs: "40%", sm: "40%", md: '35%', lg: "35%", xl: "25%" }}>
                                    <div className='w-100 h-100 scroll-no-scrollbar'>
                                        <Topics language={this.props.settings.language} closeTopic={this.closeTopic} width={this.props.width} topics={this.state.topics} myId={this.props.myId} setMessenger={this.setMessenger} messenger={this.state.messenger} messengerInfo={this.state.messengerInfo} colors={this.props.colors} />
                                    </div>
                                </SidebarView>
                                {/* {this.state.messengerInfo ? (
                                    <>
                                        {console.log('messsssengerinfo', true)}
                                        <GroupInformation topics={this.state.topics} language={this.props.language} messenger={this.state.messenger} isLoader={this.state.isLoader} myId={this.state.myId} messengerInfo={this.state.messengerInfo} setData={this.setData} width={this.props.width} removeUser={this.removeUser} setMessenger={this.setMessenger} />
                                    </>
                                ) : (
                                    <MessengerList language={this.props.language} selectApplet={this.selectApplet} isApplet={this.props.isApplet} variables={this.props.variables} page={this.props.page}
                                        openOne={this.props.openOne} closeOne={this.closeOne} messenger={this.state.messenger} width={this.props.width} adminView={true} functionsHandler={this.functionsHandler} />
                                )} */}
                            </div>
                        </Responsive>
                        <Responsive width={this.props.width} height="100%" media={{ xs: this.state.messengerInfo ? "12" : 'none', sm: this.state.messengerInfo ? "12" : 'none', md: '8', lg: "8", xl: "9" }}>
                            <div ref={el => this.MessengerView = el} className="w-100 h-100 position-relative p-0" >
                                <div className="w-100 h-100" >

                                    <MessengerView
                                        page={this.props.page}
                                        frame={this.props.page}
                                        adminView={this.props.adminView}

                                        variables={this.props.variables}
                                        sendNotif={this.sendNotif}
                                        setMessenger={this.setMessenger}
                                        topics={this.state.topics}
                                        messenger={this.state.messenger}

                                        potentialUser={this.state.potentialUser}
                                        potentialFrame={this.state.potentialFrame}
                                        myPotentialFrame={this.state.myPotentialFrame}
                                        height={this.props.mheight}
                                        currentApplet={this.state.currentApplet}
                                        isApplet={this.props.isApplet}
                                        selectApplet={this.selectApplet}
                                        showClose={false}
                                        setData={this.setData}
                                        openTopics={this.openTopics}
                                        setTopics={this.setTopics}
                                        messengerInfo={this.state.messengerInfo}
                                        showBack={conditionalWidth(this.props.width, { xs: true, sm: true, md: true, lg: false })}
                                        close={() => this.setState({ showMessenger: false }, () => this.updateWidth())}
                                        askForForm={false}
                                        closeOne={this.closeOne}
                                        width={this.props.width}
                                        language={this.props.language}
                                        appletAccess={this.props.appletAccess}
                                        applet={this.props.applet}
                                        colors={this.props.colors}
                                    />
                                </div>
                            </div>
                        </Responsive>
                    </div>
                    <SettingsSwitcher showHeader={this.showHeader} changeMessengerStage={this.changeMessengerStage} updateConnectionPermissions={this.props.updateConnectionPermissions} stageName={'settings'} permissions={this.props.permissions} pageChangePage={this.pageChangePage} accessPages={this.props.accessPages} accessSections={this.props.accessSections} frames={this.props.frames} scrollToTop={this.scrollToTop} ref={el => this.settingsSwitcher = el} setData={this.setData} setHeader={this.setHeader} changeWindow={this.changeWindow} colors={this.props.colors} width={this.props.width} height={this.props.height} baseUrl={[...this.props.baseUrl, 'settings']} language={this.props.language} applet={this.props.applet} pages={this.state.pages} page={this.state.page} stage={1} modules={this.state.modules} user={this.props.user} changeWindowLink={this.props.changeWindowLink} changePage={this.changePage} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} functionsHandler={this.functionsHandler} windowData={this.props.windowData} route={this.props.baseUrl} variables={this.props.variables} closeWindow={this.props.closeWindow} appletAccess={this.props.appletAccess} />
                </StagesManager>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessengerAdminView);